function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6 15C13.7408 15 13.04 15.7008 13.04 16.56V23.7425C13.7144 23.1575 14.5675 22.6842 15.64 22.3125V20.2C15.64 18.8167 18.0024 18.64 20.06 18.64C22.1177 18.64 24.48 18.8167 24.48 20.2V21.24C24.6547 21.238 24.8213 21.24 25 21.24C25.1788 21.24 25.3453 21.238 25.52 21.24V20.2C25.52 18.8167 27.8823 18.64 29.94 18.64C31.9976 18.64 34.36 18.8167 34.36 20.2V22.2962C35.4305 22.6659 36.2795 23.1494 36.96 23.7425V16.56C36.96 15.7008 36.2592 15 35.4 15H14.6ZM25 22.28C15.0713 22.28 11.9919 24.1162 12 29.04H38C38.0081 24.0837 34.9287 22.28 25 22.28ZM12 30.08V35.8H15.64V33.72C15.64 32.9725 15.9325 32.68 16.68 32.68H33.32C34.0675 32.68 34.36 32.9725 34.36 33.72V35.8H38V30.08H12Z"
});

function SvgIc5D5F8974Fc0611Eb9A030242Ac130003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc5D5F8974Fc0611Eb9A030242Ac130003);
export default ForwardRef;